module.exports = __webpack_public_path__ + "static/media/sal.62ac09c3.png";